import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(props, _ref) {
    var $, $f7, $f7route, $f7router, $on, $update, user, avatar, editHesitate, hesitate, analysistype_visibility, types, image, vw, vh, isCordovaIOS, fetchImage, storageImage, rotateImage, deleteItem, shareHesitate, shareViaWA1, shareViaWA, openDocument, share, toggleEdit, clear, hesitateChangeType, showImage, webOpenImageBrowser, getFileBrowser, video, canvas, stream, showCamera, saveCamera, stopCamera, saveImage, qrscan, validateFields, clickOnDocument, clickOnImage, save;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            $ = _ref.$, $f7 = _ref.$f7, $f7route = _ref.$f7route, $f7router = _ref.$f7router, $on = _ref.$on, $update = _ref.$update;

            if (!myApp.children) {
              _context21.next = 7;
              break;
            }

            _context21.next = 4;
            return myApp.getChildren();

          case 4:
            _context21.t0 = _context21.sent;
            _context21.next = 10;
            break;

          case 7:
            _context21.next = 9;
            return myApp.user();

          case 9:
            _context21.t0 = _context21.sent;

          case 10:
            user = _context21.t0;
            _context21.next = 13;
            return myStorage.get(user.data.avatar);

          case 13:
            _context21.t2 = _context21.sent;

            if (_context21.t2) {
              _context21.next = 16;
              break;
            }

            _context21.t2 = user.data.avatar;

          case 16:
            _context21.t1 = _context21.t2;

            if (_context21.t1) {
              _context21.next = 19;
              break;
            }

            _context21.t1 = 'static/pet.svg';

          case 19:
            avatar = _context21.t1;
            editHesitate = props.id === '_new' || $f7route.query.edit;
            hesitate = {
              id: props.id === '_new' ? Date.now() : props.id,
              image: ''
            };
            analysistype_visibility = 'hidden';
            types = {
              tratment: 'Trattamento',
              vacc: lng.vaccine,
              analysis: lng.analysis,
              pressure: lng.analysis_type_7
            };
            vw = window.innerWidth, vh = window.innerHeight;
            isCordovaIOS = $f7.device.cordova && $f7.device.ios;
            console.log(hesitate);

            fetchImage = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return myStorage.get(hesitate.image);

                      case 2:
                        data = _context.sent;

                        if (!data) {
                          _context.next = 7;
                          break;
                        }

                        return _context.abrupt("return", true);

                      case 7:
                        storageImage();

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function fetchImage() {
                return _ref3.apply(this, arguments);
              };
            }();

            storageImage = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var b64;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return $f7.fetchImage(hesitate.image);

                      case 2:
                        b64 = _context2.sent;
                        if (b64) myStorage.set(hesitate.image, b64);

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function storageImage() {
                return _ref4.apply(this, arguments);
              };
            }();
            /*
             * 
             * Carica esito
             */


            if (props.id !== '_new') {
              user.data.hesitates = user.data.hesitates || [];
              user.data.hesitates.forEach( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(e.id == props.id)) {
                            _context3.next = 11;
                            break;
                          }

                          hesitate = e;
                          console.log(hesitate);
                          _context3.next = 5;
                          return myStorage.get(hesitate.image);

                        case 5:
                          _context3.t0 = _context3.sent;

                          if (_context3.t0) {
                            _context3.next = 8;
                            break;
                          }

                          _context3.t0 = hesitate.image;

                        case 8:
                          image = _context3.t0;
                          $update();
                          fetchImage();

                        case 11:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());
            }

            rotateImage = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                var oldImage, newImage;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;
                        $f7.preloader.show();
                        oldImage = hesitate.image;
                        _context4.next = 5;
                        return myApp.server.putJSON('image/rotate', {
                          src: hesitate.image
                        });

                      case 5:
                        newImage = _context4.sent;
                        hesitate.image = newImage.src;
                        if (validateFields(true)) save(true);
                        _context4.next = 10;
                        return storageImage();

                      case 10:
                        myStorage.deleteItem(oldImage);
                        _context4.next = 16;
                        break;

                      case 13:
                        _context4.prev = 13;
                        _context4.t0 = _context4["catch"](0);
                        $f7.alertError(_context4.t0);

                      case 16:
                        _context4.prev = 16;
                        $f7.preloader.hide();
                        return _context4.finish(16);

                      case 19:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[0, 13, 16, 19]]);
              }));

              return function rotateImage() {
                return _ref6.apply(this, arguments);
              };
            }();

            deleteItem = function deleteItem() {
              $f7.dialog.confirm(lng.delete_item_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.prev = 0;
                        $f7.preloader.show();
                        _context5.next = 4;
                        return myApp.server.deleteJSON('user/me/hesitate/' + hesitate.id + '?children=' + (myApp.children || ''));

                      case 4:
                        user.data.hesitates = _context5.sent;

                        if (!myApp.children) {
                          _context5.next = 10;
                          break;
                        }

                        _context5.next = 8;
                        return myApp.setChildren(user);

                      case 8:
                        _context5.next = 12;
                        break;

                      case 10:
                        _context5.next = 12;
                        return myApp.user(user);

                      case 12:
                        $f7router.back();
                        _context5.next = 18;
                        break;

                      case 15:
                        _context5.prev = 15;
                        _context5.t0 = _context5["catch"](0);
                        console.log(_context5.t0);

                      case 18:
                        _context5.prev = 18;
                        $f7.preloader.hide();
                        return _context5.finish(18);

                      case 21:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[0, 15, 18, 21]]);
              })));
            };
            /**
             * Usa cordova-plugin-x-socialsharing
             * https://www.npmjs.com/package/cordova-plugin-x-socialsharing
             * 
             * @returns {undefined}
             */


            shareHesitate = function shareHesitate() {
              var message,
                  file,
                  w = window.innerWidth;

              switch (hesitate.type) {
                case 'analysis':
                  message = user.data.lastname + ', ' + user.data.name + ' \n' + lng.analysis + ': ' + hesitate.analysistype + ' \n' + lng.values + ': ' + hesitate.analysisvalue + ' \n' + lng.date + ': ' + hesitate.date + ' \n' + hesitate.structure + ' \n' + (hesitate.notes ? hesitate.notes + ' \n' : '') + ((hesitate.document || {}).url ? ' \n' + hesitate.document.url + ' \n' : '') + (hesitate.image ? ' \n' + hesitate.image + ' \n' : '') + (hesitate.qrcode ? ' \n' + myApp.server.host + 'qrcode/hesitate/' + user.usercode + '/' + hesitate.id + '.png\n' : '');
                  break;

                case 'tratment':
                  message = user.data.lastname + ', ' + user.data.name + ' \n' + 'Trattamento' + ': ' + hesitate.trattype + ' \n' + 'Scadenza' + ': ' + hesitate.scadenza + ' \n' + lng.date + ': ' + hesitate.date + ' \n' + hesitate.structure + ' \n' + (hesitate.notes ? hesitate.notes + ' \n' : '') + ((hesitate.document || {}).url ? ' \n' + hesitate.document.url + ' \n' : '') + (hesitate.image ? ' \n' + hesitate.image + ' \n' : '') + (hesitate.qrcode ? ' \n' + myApp.server.host + 'qrcode/hesitate/' + user.usercode + '/' + hesitate.id + '.png\n' : '');
                  break;

                case 'vacc':
                  message = user.data.lastname + ', ' + user.data.name + ' \n' + lng.vac + ': ' + hesitate.vacctype + ' \n' + 'Lotto' + ': ' + hesitate.lotto + ' \n' + lng.date + ': ' + hesitate.date + ' \n' + 'Richiamo: ' + hesitate.richiamo + ' \n' + (hesitate.notes ? hesitate.notes + ' \n' : '') + ((hesitate.document || {}).url ? ' \n' + hesitate.document.url + ' \n' : '') + (hesitate.image ? ' \n' + hesitate.image + ' \n' : '') + (hesitate.qrcode ? ' \n' + myApp.server.host + 'qrcode/hesitate/' + user.usercode + '/' + hesitate.id + '.png\n' : '');
                  break;

                case 'tamp':
                  message = user.data.lastname + ', ' + user.data.name + ' \n' + lng.tamp + ': ' + hesitate.tamptype + ' \n' + lng.hesitate + ': ' + hesitate.tampnumber + ' \n' + lng.date + ': ' + hesitate.date + ' \n' + hesitate.structure + ' \n' + (hesitate.notes ? hesitate.notes + ' \n' : '') + ((hesitate.document || {}).url ? ' \n' + hesitate.document.url + ' \n' : '') + (hesitate.image ? ' \n' + hesitate.image + ' \n' : '') + (hesitate.qrcode ? ' \n' + myApp.server.host + 'qrcode/hesitate/' + user.usercode + '/' + hesitate.id + '.png\n' : '');
                  break;

                case 'pressure':
                  message = user.data.lastname + ', ' + user.data.name + ' \n' + lng.analysis + ': ' + lng.analysis_type_7 + ' \n' + 'PAS (min): ' + hesitate['press-min'] + ' mmHg \n' + 'PAD (max): ' + hesitate['press-max'] + ' mmHg \n' + lng.date + ': ' + hesitate.date + ' \n' + hesitate.structure + ' \n' + (hesitate.notes ? hesitate.notes + ' \n' : '') + ((hesitate.document || {}).url ? ' \n' + hesitate.document.url + ' \n' : '') + (hesitate.image ? ' \n' + hesitate.image + ' \n' : '') + (hesitate.qrcode ? ' \n' + myApp.server.host + 'qrcode/hesitate/' + user.usercode + '/' + hesitate.id + '.png\n' : '');
                  break;
              }

              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_app,
                  color: 'gray'
                }, {
                  icon: '<i class="f7-icons">at</i>',
                  text: lng.share_via_email,
                  color: 'blue',
                  onClick: function onClick() {
                    var mytypes = {
                      analysis: lng.analysis,
                      tamp: lng.esitate + ' ' + lng.tamp,
                      vacc: lng.v_certificate
                    };
                    var files = [];
                    if (hesitate.qrcode) files.push(hesitate.qrcode);
                    if (hesitate.image) files.push(hesitate.image);
                    if (hesitate.document && hesitate.document.url) files.push(hesitate.document.url);
                    if (!files.length) files = null;
                    if (!$f7.device.cordova) return $f7.webShareViaEmail(lng.share + ' ' + mytypes[hesitate.type], message);
                    window.plugins.socialsharing.canShareViaEmail(function () {
                      /**
                       * message 
                       * can contain HTML tags, but support on Android is rather limited:  
                       * http://stackoverflow.com/questions/15136480/how-to-send-html-content-with-image-through-android-default-email-client
                       */
                      window.plugins.socialsharing.shareViaEmail(message, lng.share + ' ' + mytypes[hesitate.type], null, // TO: must be null or an array
                      null, // CC: must be null or an array
                      null, // BCC: must be null or an array
                      files, // FILES: can be null, a string, or an array
                      function (onSuccess) {
                        // called when sharing worked, but also when the user cancelled sharing via email. 
                        // On iOS, the callbacks' boolean result parameter is true when sharing worked, false if cancelled. 
                        // On Android, this parameter is always true so it can't be used. 
                        console.log('Share via email success');
                        if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                      }, function (onError) {
                        // called when sh*t hits the fan
                        $f7.dialog.alert(lng.error_message + '<br/>' + onError, function () {
                          if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                        });
                      });
                    }, function () {
                      window.plugins.socialsharing.shareWithOptions({
                        message: message,
                        chooserTitle: lng.select_app
                      }, function () {
                        if (w !== window.innerWidth) window.location.reload();
                      }, function () {
                        if (w !== window.innerWidth) window.location.reload();
                      });
                    });
                  }
                }, {
                  icon: '<i class="f7-icons">chat_bubble_text</i>',
                  text: lng.share_via_wa,
                  color: 'blue',
                  onClick: function onClick() {
                    if (!$f7.device.cordova) $f7.webShareViaWA(message);else shareViaWA(message);
                  }
                }, {
                  icon: '',
                  text: 'Annulla',
                  color: 'gray'
                }]
              }).open();
            };

            shareViaWA1 = function shareViaWA1(msg) {
              var w = window.innerWidth;
              window.plugins.socialsharing.shareViaWhatsApp(msg, null, null, function (success) {
                if (w !== window.innerWidth) window.location.reload();
              }, function (errormsg) {
                return $f7.dialog.alert(lng.error_message + '<br/>' + errormsg);
              }, function () {
                if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
              });
            };

            shareViaWA = function shareViaWA(msg) {
              var w = window.innerWidth;
              window.plugins.socialsharing.canShareVia('whatsapp', 'msg', null, null, null, shareViaWA1, function () {
                window.plugins.socialsharing.shareWithOptions({
                  message: msg,
                  chooserTitle: lng.select_app
                }, function () {
                  if (w !== window.innerWidth) window.location.reload();
                }, function () {
                  if (w !== window.innerWidth) window.location.reload();
                });
              });
            };
            /**
             * Apre documento vi inAppBrowser
             * 
             * @returns {Window}
             */


            openDocument = function openDocument() {
              return myApp.iab(hesitate.document.url, '_system');
            };
            /**
             * Usa cordova-plugin-x-socialsharing
             * https://www.npmjs.com/package/cordova-plugin-x-socialsharing
             * 
             * @returns {undefined}
             */


            share = function share() {
              if ($f7.device.cordova) {
                var options = {
                  message: '',
                  subject: lng.share_file,
                  files: [],
                  url: '...',
                  chooserTitle: lng.select_app
                };
                var w = window.innerWidth;

                var onSuccess = function onSuccess(result) {
                  if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                };

                var onError = function onError(msg) {
                  console.log("Sharing failed with message: " + msg, function () {
                    if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                  });
                };

                window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
              } else {
                $f7.dialog.alert('Social sharing non disponibile');
              }
            };

            toggleEdit = function toggleEdit() {
              editHesitate = !editHesitate;

              if (props.id === '_new') {
                $f7router.navigate('/hesitates/');
              } else {
                $update().then(function () {
                  if (editHesitate) {
                    var ok = false;
                    $('#type').find('option').forEach(function (e) {
                      if (e.value == hesitate.type) {
                        ok = true;
                        e.selected = true;
                      } else if (e.value == hesitate.analysistype) {
                        ok = true;
                        e.selected = true;
                      } else if (e.dataset.type === hesitate.type) {
                        ok = true;
                        e.selected = true;
                      }
                    });

                    if (!ok) {
                      $('#type').val('1');
                      analysistype_visibility = '';
                    } else {
                      analysistype_visibility = 'hidden';
                    }

                    $update();
                  }
                });
              }
            };
            /*
             * Reimposta campi
             */


            clear = function clear() {
              'producer structure tamptype tampnumber analysistype analysisvalue dose date notes press-min press-max'.split(' ').forEach(function (k) {
                $('[name=' + k + ']').val('');
              });
            };
            /*
             * IMposta campi visibili secondo il tipo
             * @param {type} ev
             * @returns {undefined}
             */


            hesitateChangeType = function hesitateChangeType(ev) {
              var getValue = function getValue() {
                var v;
                $('#type').find('option').forEach(function (e) {
                  if (e.selected) v = e.value;
                });
                console.log(v);
                return v;
              };

              var getType = function getType() {
                var v;
                $('#type').find('option').forEach(function (e) {
                  if (e.selected) v = $(e).data('type');
                });
                return v;
              };

              hesitate.type = ev.target.value !== '-' ? getType() : '';

              if (hesitate.type === 'analysis') {
                var value = getValue();

                if (value === '1') {
                  hesitate.analysistype = '';
                  analysistype_visibility = '';
                } else {
                  hesitate.analysistype = value;
                  analysistype_visibility = 'hidden';
                }
              }

              clear();
              $update();
            };
            /*
             * Mostra immagine nel PhotoBrowser
             * @returns {undefined}
             */


            showImage = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ev) {
                var type, img;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        type = typeof ev === 'string' ? ev : $(ev.target).data('type'); // : 'image';

                        _context6.next = 3;
                        return myStorage.get(hesitate[type]);

                      case 3:
                        _context6.t0 = _context6.sent;

                        if (_context6.t0) {
                          _context6.next = 6;
                          break;
                        }

                        _context6.t0 = hesitate[type];

                      case 6:
                        img = _context6.t0;
                        $f7.photoBrowser.create({
                          photos: [img],
                          swipeToClose: true,
                          toolbar: false,
                          popupCloseLinkText: 'Chiudi'
                        }).open();

                      case 8:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function showImage(_x4) {
                return _ref8.apply(this, arguments);
              };
            }();

            webOpenImageBrowser = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", new Promise(function (resolve, reject) {
                          var fileInput = document.getElementById('fileDialogId1');

                          var openFileDialog = function openFileDialog() {
                            return fileInput.click();
                          };

                          fileInput.onchange = function (ev) {
                            var file = ev.target.files[0];
                            var reader = new FileReader();
                            reader.readAsDataURL(file);

                            reader.onload = function () {
                              var img = reader.result;
                              resolve(img);
                            };

                            reader.onerror = function (error) {
                              console.log('Error: ', error);
                              reject(error);
                            };
                          };

                          openFileDialog();
                        }));

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function webOpenImageBrowser() {
                return _ref9.apply(this, arguments);
              };
            }();
            /**
             * Apre file dialog e ritorna il file selezionato
             * @returns {Promise}
             */


            getFileBrowser = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        return _context8.abrupt("return", new Promise(function (resolve, reject) {
                          var fileInput = document.getElementById('filePDF1');

                          var openFileDialog = function openFileDialog() {
                            return fileInput.click();
                          };

                          fileInput.onchange = function (ev) {
                            var file = ev.target.files[0];
                            var reader = new FileReader();
                            reader.readAsDataURL(file);

                            reader.onload = function () {
                              //const file = reader.result;
                              // resolve(file);
                              var f = {
                                dataURI: reader.result,
                                name: file.name
                              };
                              resolve(f);
                            };

                            reader.onerror = function (error) {
                              console.log('Error: ', error);
                              reject(error);
                            };
                          };

                          openFileDialog();
                        }));

                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function getFileBrowser() {
                return _ref10.apply(this, arguments);
              };
            }();
            /*
             * Camera for webapp
             */


            showCamera = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        video = document.querySelector("#video");
                        canvas = document.querySelector("#canvas");
                        _context9.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                          video: {
                            facingMode: "environment"
                          },
                          audio: false
                        });

                      case 4:
                        stream = _context9.sent;
                        video.srcObject = stream;

                      case 6:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function showCamera() {
                return _ref11.apply(this, arguments);
              };
            }();

            saveCamera = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var img, data, oldImage;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        console.log(canvas.width, canvas.height);
                        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                        img = canvas.toDataURL('image/jpeg');
                        $f7.popup.close();
                        /*
                         $f7.preloader.show()
                         try {
                         let text = await myApp.server.postJSON('qrcodeScanner', {src:img});
                         } catch(err) {
                         return $f7.dialog.alert(lng.error_message +  '<br> Impossibile leggere il qrcode. ');
                         
                         } finally {
                         $f7.preloader.hide();
                         }
                         addQRCode(text);
                         */

                        $f7.preloader.show();
                        _context10.prev = 5;
                        _context10.next = 8;
                        return myApp.server.putJSON('user/me/hesitate/image', {
                          img: img
                        });

                      case 8:
                        data = _context10.sent;
                        oldImage = hesitate.image; //imposta proprietà hesitate.image

                        hesitate.image = data.url;
                        myStorage.set(data.url, img); // se esito in modalità edit (non nuovo) salva

                        save(true);
                        if (oldImage) myStorage.deleteItem(oldImage);
                        _context10.next = 19;
                        break;

                      case 16:
                        _context10.prev = 16;
                        _context10.t0 = _context10["catch"](5);
                        $f7.dialog.alert(lng.error_message + '<br/>' + (_context10.t0.code ? _context10.t0.code + ' ' : '') + _context10.t0.message);

                      case 19:
                        _context10.prev = 19;
                        $f7.preloader.hide();
                        return _context10.finish(19);

                      case 22:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10, null, [[5, 16, 19, 22]]);
              }));

              return function saveCamera() {
                return _ref12.apply(this, arguments);
              };
            }();

            stopCamera = function stopCamera() {
              stream.getTracks().forEach(function (track) {
                if (track.readyState == 'live') {
                  track.stop();
                }
              });
            };
            /*
             * Scatta foto e salva immagine
             * @returns {unresolved}
             */


            saveImage = /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        if ($f7.device.cordova || true) {
                          $f7.actions.create({
                            buttons: [{
                              label: true,
                              text: lng.image_select_source,
                              color: 'gray'
                            }, {
                              icon: '<i class="icon f7-icons">qrcode_viewfinder</i>',
                              text: lng.scan_qrcode,
                              color: 'blue',
                              onClick: qrscan
                            }, {
                              icon: '<i class="icon f7-icons">camera</i>',
                              text: lng.camera,
                              color: 'blue',
                              onClick: function () {
                                var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                                  var img, data, oldImage;
                                  return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                                    while (1) {
                                      switch (_context11.prev = _context11.next) {
                                        case 0:
                                          if (!$f7.device.cordova) {
                                            _context11.next = 6;
                                            break;
                                          }

                                          _context11.next = 3;
                                          return myApp.cordova.camera({
                                            back: true
                                          });

                                        case 3:
                                          img = _context11.sent;
                                          _context11.next = 9;
                                          break;

                                        case 6:
                                          _context11.next = 8;
                                          return webOpenImageBrowser();

                                        case 8:
                                          img = _context11.sent;

                                        case 9:
                                          $f7.preloader.show();
                                          _context11.prev = 10;
                                          _context11.next = 13;
                                          return myApp.server.putJSON('user/me/hesitate/image', {
                                            img: img
                                          });

                                        case 13:
                                          data = _context11.sent;
                                          oldImage = hesitate.image;
                                          hesitate.image = img;
                                          $update();
                                          hesitate.image = data.url;
                                          myStorage.set(data.url, img); // se esito in modalità edit (non nuovo) salva

                                          save(true);
                                          if (oldImage) myStorage.deleteItem(oldImage);
                                          _context11.next = 26;
                                          break;

                                        case 23:
                                          _context11.prev = 23;
                                          _context11.t0 = _context11["catch"](10);
                                          $f7.dialog.alert(lng.error_message + '<br/>' + (_context11.t0.code ? _context11.t0.code + ' ' : '') + _context11.t0.message);

                                        case 26:
                                          _context11.prev = 26;
                                          $f7.preloader.hide();
                                          return _context11.finish(26);

                                        case 29:
                                        case "end":
                                          return _context11.stop();
                                      }
                                    }
                                  }, _callee11, null, [[10, 23, 26, 29]]);
                                }));

                                function onClick() {
                                  return _onClick.apply(this, arguments);
                                }

                                return onClick;
                              }()
                            }, {
                              icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                              text: lng.gallery,
                              color: 'blue',
                              onClick: function () {
                                var _onClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                                  var img, data, oldImage;
                                  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                                    while (1) {
                                      switch (_context12.prev = _context12.next) {
                                        case 0:
                                          if (!$f7.device.cordova) {
                                            _context12.next = 6;
                                            break;
                                          }

                                          _context12.next = 3;
                                          return myApp.cordova.camera({
                                            gallery: true
                                          });

                                        case 3:
                                          img = _context12.sent;
                                          _context12.next = 9;
                                          break;

                                        case 6:
                                          _context12.next = 8;
                                          return webOpenImageBrowser();

                                        case 8:
                                          img = _context12.sent;

                                        case 9:
                                          $f7.preloader.show();
                                          _context12.prev = 10;
                                          _context12.next = 13;
                                          return myApp.server.putJSON('user/me/hesitate/image', {
                                            img: img
                                          });

                                        case 13:
                                          data = _context12.sent;
                                          oldImage = hesitate.image; // mostra immagine nel form

                                          hesitate.image = img;
                                          $update(); //imposta proprietà hesitate.image

                                          hesitate.image = data.url;
                                          myStorage.set(data.url, img); // se esito in modalità edit (non nuovo) salva

                                          save(true);
                                          if (oldImage) myStorage.deleteItem(oldImage);
                                          _context12.next = 26;
                                          break;

                                        case 23:
                                          _context12.prev = 23;
                                          _context12.t0 = _context12["catch"](10);
                                          $f7.dialog.alert(lng.error_message + '<br/>' + (_context12.t0.code ? _context12.t0.code + ' ' : '') + _context12.t0.message);

                                        case 26:
                                          _context12.prev = 26;
                                          $f7.preloader.hide();
                                          return _context12.finish(26);

                                        case 29:
                                        case "end":
                                          return _context12.stop();
                                      }
                                    }
                                  }, _callee12, null, [[10, 23, 26, 29]]);
                                }));

                                function onClick() {
                                  return _onClick2.apply(this, arguments);
                                }

                                return onClick;
                              }()
                            }, {
                              icon: '<i class="icon f7-icons">doc_richtext</i>',
                              text: lng.pdf_file,
                              color: 'blue',
                              onClick: function () {
                                var _onClick3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                                  var file, data;
                                  return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                                    while (1) {
                                      switch (_context13.prev = _context13.next) {
                                        case 0:
                                          if (!$f7.device.cordova) {
                                            _context13.next = 6;
                                            break;
                                          }

                                          _context13.next = 3;
                                          return chooser.getFile('application/pdf');

                                        case 3:
                                          file = _context13.sent;
                                          _context13.next = 9;
                                          break;

                                        case 6:
                                          _context13.next = 8;
                                          return getFileBrowser();

                                        case 8:
                                          file = _context13.sent;

                                        case 9:
                                          if (file) {
                                            _context13.next = 11;
                                            break;
                                          }

                                          return _context13.abrupt("return");

                                        case 11:
                                          _context13.prev = 11;
                                          $f7.preloader.show();
                                          _context13.next = 15;
                                          return myApp.server.putJSON('user/me/hesitate/document', {
                                            data: file.dataURI,
                                            name: file.name
                                          });

                                        case 15:
                                          data = _context13.sent;
                                          hesitate.document = data;
                                          $update();

                                          if (validateFields(true)) {
                                            save(true);
                                          }

                                          _context13.next = 24;
                                          break;

                                        case 21:
                                          _context13.prev = 21;
                                          _context13.t0 = _context13["catch"](11);
                                          console.log(lng.error_message + '<br/>' + (_context13.t0.code ? _context13.t0.code + ' ' : '') + _context13.t0.message);

                                        case 24:
                                          _context13.prev = 24;
                                          $f7.preloader.hide();
                                          return _context13.finish(24);

                                        case 27:
                                        case "end":
                                          return _context13.stop();
                                      }
                                    }
                                  }, _callee13, null, [[11, 21, 24, 27]]);
                                }));

                                function onClick() {
                                  return _onClick3.apply(this, arguments);
                                }

                                return onClick;
                              }()
                            }, {
                              text: lng.cancel,
                              color: 'red'
                            }]
                          }).open();
                        } else {
                          // debug web
                          $f7.dialog.alert('Non disponibile');
                        }

                      case 1:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              }));

              return function saveImage() {
                return _ref13.apply(this, arguments);
              };
            }();
            /*
             * Scan QRCode
             * @returns {unresolved}
             */


            qrscan = /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
                var setQrcode, result;
                return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        setQrcode = /*#__PURE__*/function () {
                          var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(text) {
                            var data, b64;
                            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                              while (1) {
                                switch (_context15.prev = _context15.next) {
                                  case 0:
                                    $f7.preloader.show();
                                    _context15.prev = 1;
                                    _context15.next = 4;
                                    return myApp.server.putJSON('user/me/hesitate/qrcode', {
                                      text: text
                                    });

                                  case 4:
                                    data = _context15.sent;
                                    b64 = data.qrcode; // view qrcode

                                    hesitate.qrcode = data.qrcode;
                                    $update(); // store qrcode

                                    if (validateFields(true)) {
                                      save(true);
                                    }

                                    _context15.next = 14;
                                    break;

                                  case 11:
                                    _context15.prev = 11;
                                    _context15.t0 = _context15["catch"](1);
                                    $f7.dialog.alert(lng.error_message + '<br/>' + (_context15.t0.code ? _context15.t0.code + ' ' : '') + _context15.t0.message);

                                  case 14:
                                    _context15.prev = 14;
                                    $f7.preloader.hide();
                                    return _context15.finish(14);

                                  case 17:
                                  case "end":
                                    return _context15.stop();
                                }
                              }
                            }, _callee15, null, [[1, 11, 14, 17]]);
                          }));

                          return function setQrcode(_x5) {
                            return _ref15.apply(this, arguments);
                          };
                        }();

                        if ($f7.device.cordova) {
                          _context17.next = 7;
                          break;
                        }

                        _context17.next = 4;
                        return $f7.pwaQrcodeScanner();

                      case 4:
                        result = _context17.sent;
                        if (result && result.text) setQrcode(result.text);
                        return _context17.abrupt("return");

                      case 7:
                        cordova.plugins.barcodeScanner.scan( /*#__PURE__*/function () {
                          var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(result) {
                            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                              while (1) {
                                switch (_context16.prev = _context16.next) {
                                  case 0:
                                    if (!(result.canceled || !result.text)) {
                                      _context16.next = 2;
                                      break;
                                    }

                                    return _context16.abrupt("return");

                                  case 2:
                                    setQrcode(result.text);

                                  case 3:
                                  case "end":
                                    return _context16.stop();
                                }
                              }
                            }, _callee16);
                          }));

                          return function (_x6) {
                            return _ref16.apply(this, arguments);
                          };
                        }(), function (error) {
                          console.log("Scanning failed: " + error);
                        }, {
                          preferFrontCamera: false,
                          // iOS and Android
                          showFlipCameraButton: true,
                          // iOS and Android
                          showTorchButton: true,
                          // iOS and Android
                          torchOn: false,
                          // Android, launch with the torch switched on (if available)
                          saveHistory: false,
                          // Android, save scan history (default false)
                          prompt: lng.qrscan_prompt,
                          // Android
                          resultDisplayDuration: 500,
                          // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                          formats: "QR_CODE,PDF_417",
                          // default: all but PDF_417 and RSS_EXPANDED
                          //orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                          disableAnimations: false,
                          // iOS
                          disableSuccessBeep: false // iOS and Android

                        });

                      case 8:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee17);
              }));

              return function qrscan() {
                return _ref14.apply(this, arguments);
              };
            }();
            /*
             * Valida campi
             * @param {type} ev
             * @returns {success}
             */


            validateFields = function validateFields(ev) {
              if (ev === true) {
                var type = hesitate.type;
                var fields = {
                  vacc: 'producer dose structure date'.split(' '),
                  tamp: 'tamptype tampnumber structure date'.split(' '),
                  analysis: 'analysistype analysisvalue structure date'.split(' '),
                  pressure: 'press-min press-max structure date'.split(' ')
                };
                if (!type) return false;
                var success = true;
                (fields[type] || []).forEach(function (k) {
                  var el = $('[name=' + k + ']');

                  if (!$f7.input.validate(el)) {
                    success = false;
                  }
                });
                return success;
              } else {
                return $f7.input.validate(ev.target);
              }
            };

            clickOnDocument = function clickOnDocument() {
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_action,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">doc_richtext</i>',
                  text: lng.open,
                  color: 'blue',
                  onClick: function onClick() {
                    // Apre il file nel browser predefinito del Device
                    var url = hesitate.document.url;
                    myApp.iab(url, '_system');
                  }
                }, {
                  icon: '<i class="icon f7-icons">square_arrow_up_on_square</i>',
                  text: lng.share,
                  color: 'blue',
                  onClick: function onClick() {
                    // condividi tramite social
                    if ($f7.device.cordova) {
                      var options = {
                        message: '',
                        subject: lng.share_file,
                        files: [hesitate.document.url],
                        url: hesitate.document.url,
                        chooserTitle: lng.select_app
                      };

                      var onSuccess = function onSuccess(result) {
                        if ($f7.device.ios) window.location.reload();
                      };

                      var onError = function onError(msg) {
                        console.log("Sharing failed with message: " + msg);
                        if ($f7.device.ios) window.location.reload();
                      };

                      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
                    } else {
                      $f7.dialog.alert('Social sharing non disponibile');
                    }
                  }
                }, {
                  icon: '<i class="icon f7-icons">trash</i>',
                  text: lng.delete,
                  color: 'red',
                  onClick: function onClick() {
                    $f7.dialog.confirm(lng.delete_document_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
                      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                        while (1) {
                          switch (_context18.prev = _context18.next) {
                            case 0:
                              hesitate.document = '';
                              _context18.next = 3;
                              return save(true);

                            case 3:
                              $update();

                            case 4:
                            case "end":
                              return _context18.stop();
                          }
                        }
                      }, _callee18);
                    })));
                  }
                }, {
                  text: lng.cancel,
                  color: 'gray'
                }]
              }).open();
            };

            clickOnImage = function clickOnImage(ev) {
              var type = $(ev.target).data('type');
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_action,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                  text: lng.show,
                  color: 'blue',
                  onClick: function onClick() {
                    return showImage(type);
                  }
                }, {
                  icon: '<i class="icon f7-icons">square_arrow_up_on_square</i>',
                  text: lng.share,
                  color: 'blue',
                  onClick: function onClick() {
                    // condividi tramite social
                    if ($f7.device.cordova) {
                      var options = {
                        message: '',
                        subject: lng.share_image,
                        files: [hesitate[type]],
                        url: '',
                        chooserTitle: lng.select_app
                      };

                      var onSuccess = function onSuccess(result) {
                        if ($f7.device.ios) window.location.reload();
                      };

                      var onError = function onError(msg) {
                        console.log("Sharing failed with message: " + msg);
                        if ($f7.device.ios) window.location.reload();
                      };

                      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
                    } else {
                      $f7.dialog.alert('Social sharing non disponibile');
                    }
                  }
                }, {
                  icon: '<i class="icon f7-icons">trash</i>',
                  text: lng.delete,
                  color: 'red',
                  onClick: function onClick() {
                    // Elimina immagine
                    $f7.dialog.confirm(lng.delete_image_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              if (type === 'image') hesitate.image = '';else if (type === 'qrcode') hesitate.qrcode = '';
                              _context19.next = 3;
                              return save(true);

                            case 3:
                              $update();

                            case 4:
                            case "end":
                              return _context19.stop();
                          }
                        }
                      }, _callee19);
                    })));
                  }
                }, {
                  text: lng.cancel,
                  color: 'gray'
                }]
              }).open();
            };
            /*
             * Salva esito
             * @param {type} fieldsValidated
             * @returns {unresolved}
             */


            save = /*#__PURE__*/function () {
              var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(fieldsValidated) {
                var target;
                return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        target = fieldsValidated !== true ? $(fieldsValidated.target) : false;
                        $('.field').each(function (el) {
                          hesitate[el.name] = el.value;
                        });
                        /*
                         * Verifica campi obbligatori
                         */

                        if (validateFields(true)) {
                          _context20.next = 5;
                          break;
                        }

                        if (target.data('show-toast') == 'true') $f7.toastError({
                          message: lng.all_fields_are_required_message
                        });
                        return _context20.abrupt("return", false);

                      case 5:
                        /*
                         * Invia oggetto hesitate al server e re-imposta array user.hesitates, quindi salva user (myApp.user(user);
                         */
                        $f7.preloader.show();
                        _context20.prev = 6;
                        hesitate.saved = true;
                        hesitate.children = myApp.children;
                        _context20.next = 11;
                        return myApp.server.putJSON('user/me/hesitate', hesitate);

                      case 11:
                        user.data.hesitates = _context20.sent;

                        if (!myApp.children) {
                          _context20.next = 17;
                          break;
                        }

                        _context20.next = 15;
                        return myApp.setChildren(user);

                      case 15:
                        _context20.next = 19;
                        break;

                      case 17:
                        _context20.next = 19;
                        return myApp.user(user);

                      case 19:
                        $update();
                        if (target && target.data('show-toast') == 'true') $f7.toastSuccess(lng.saved_ok);
                        _context20.next = 26;
                        break;

                      case 23:
                        _context20.prev = 23;
                        _context20.t0 = _context20["catch"](6);
                        $f7.toastError(_context20.t0);

                      case 26:
                        _context20.prev = 26;
                        $f7.preloader.hide();
                        return _context20.finish(26);

                      case 29:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee20, null, [[6, 23, 26, 29]]);
              }));

              return function save(_x7) {
                return _ref19.apply(this, arguments);
              };
            }(); //console.log(editHesitate, 'editHesitate');


            return _context21.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="hesitate">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">
          ${editHesitate ? $h`
          <div class="display-flex align-items-center">
            <div class="avatar-small margin-left-half" style="background-image: url(${avatar})"></div>
            <div class="padding-left">${user.name}</div>
          </div>
          ` : lng.hesitates_title }
        </div>
        <div class="right">
          ${editHesitate && $h`
          <a href="#" @click=${deleteItem}>
            <i class="icon f7-icons if-not-md">trash</i>
            <i class="icon material-icons if-md">delete</i>
          </a>
          `}
          <a href="#" class="link icon-only" @click=${toggleEdit}>
            ${editHesitate && $h`
            <i class="icon f7-icons">pencil_slash</i>
            `}
            ${!editHesitate && $h`
            <i class="icon f7-icons">pencil</i>
            `}
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content hide-navbar-on-scroll">

      <!-- ------ Sezione View ------ -->
      ${!editHesitate && $h`
      <div class="unselectable">
        <div class="text-align-center">
          <img class="logo" src="static/logo.png" alt=""/>
        </div>
        <div class="avatar margin-vertical" style="background-image: url(${avatar})"></div>
        <div class='block' style="max-width: 320px; margin-left: auto; margin-right: auto">
          <h3 class='text-align-center'>${types[hesitate.type]}</h3>

          ${hesitate.type === 'tratment' && $h`
          <div>
            <strong>${lng.type}: </strong> ${hesitate.trattype}
          </div>
          <div>
            <strong>${lng.date}: </strong> ${new Date(hesitate.date).toLocaleDateString()}
          </div>
          <div>
            <strong>${lng.date}: </strong> ${new Date(hesitate.date).toLocaleDateString()}
          </div>
          <div>
            <strong>${lng.expiry_date}: </strong> ${hesitate.scadenza ? new Date(hesitate.scadenza).toLocaleDateString() : ''}
          </div>
          <div>
            <strong>${lng.spot}: </strong> ${hesitate.structure}
          </div>
          <div>
            <strong>${lng.notes}: </strong> ${hesitate.notes}
          </div>
          `}

          ${hesitate.type === 'vacc' && $h`
          <h3 class='text-align-center'>Vaccino</h3>
          <div>
            <strong>${lng.type}: </strong> ${hesitate.vacctype}
          </div>
          <div>
            <strong>${lng.date}: </strong> ${new Date(hesitate.date).toLocaleDateString()}
          </div>
          <div>
            <strong>${lng.recall}: </strong> ${new Date(hesitate.richiamo).toLocaleDateString()}
          </div>
          <!--<div>
            <strong>${lng.spot}: </strong> ${hesitate.structure}
          </div>-->
          <div>
            <strong>${lng.notes}: </strong> ${hesitate.notes}
          </div>
          `}

          ${hesitate.type === 'analysis' && $h`
          <div>
            <strong>${lng.type}: </strong> ${hesitate.analysistype}
          </div>
          <div>
            <strong>${lng.date}: </strong> ${new Date(hesitate.date).toLocaleDateString()}
          </div>
          <div>
            <strong>${lng.value}: </strong> ${hesitate.analysisvalue}
          </div>
          <div>
            <strong>${lng.spot}: </strong> ${hesitate.structure}
          </div>
          <div>
            <strong>${lng.notes}: </strong> ${hesitate.notes}
          </div>
          `}

          ${hesitate.type === 'pressure' && $h`
          <div>
            <strong>${lng.date}: </strong> ${new Date(hesitate.date).toLocaleDateString()}
          </div>
          <div>
            <strong>PAS (min): </strong> ${hesitate['press-min']} mmHg
          </div>
          <div>
            <strong>PAD (max): </strong> ${hesitate['press-max']} mmHg
          </div>
          <div>
            <strong>${lng.spot}: </strong> ${hesitate.structure}
          </div>
          <div>
            <strong>${lng.notes}: </strong> ${hesitate.notes}
          </div>
          `}

        </div>

        <div>
          ${(hesitate.qrcode||'') && $h`
          <div class="hesitate-image" @click=${showImage} data-type="qrcode" style="background-image: url(${hesitate.qrcode})"></div>
          `}

          ${(hesitate.image || '') && $h`
          <div class="hesitate-image" @click=${showImage} data-type="image" style="background-image: url(${image})"></div>
          `}

          ${(hesitate.document || '') && $h`
          <div class="block text-align-center">
            <div class="document" style="margin: auto" @click=${openDocument}>
              <img src="static/pdf-icon.png"/>
              <div class="document-caption">${hesitate.document.name}</div>
            </div>
          </div>
          `}
        </div>

        <div class="block">
          <button class="button button-large button-round button-outline color-secondary" @click=${shareHesitate}>
            <i class="f7-icons left">square_arrow_up_on_square</i>
            ${lng.share}
          </button>
        </div>

        <div class="my-footer padding-bottom" style="z-index: 9999">
          <hr class="sep"/>
          <a href="http://www.processfarm.net" class="link external text-color-black" target="_system">
            <span>Prodotto da <img class="process-services" src="static/process-services.png"/> srl Società Benefit 
              <br/> 01549880050 - www.processfarm.net</span>
          </a>
        </div>
      </div>
      `}

      <!-- ------ Sezione Edit ------ -->
      ${editHesitate && $h`
      <div class="list mt-0">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.type} *</div>
              <div class="item-input-wrap">
                <select name="type" id="type" @change=${hesitateChangeType}>
                  <option value="-">${lng.select_type}</option>
                  <!-- <option data-type="analysis">${lng.analysis_type_0}</option> -->
                  <option data-type="tratment">${lng.analysis_type_1}</option>
                  <option data-type="analysis">${lng.analysis_type_2}</option>
                  <option data-type="analysis">${lng.analysis_type_3}</option>
                  <option data-type="analysis">${lng.analysis_type_4}</option>

                  <option data-type="vacc">${lng.analysis_type_5}</option>
                  <option data-type="analysis">${lng.analysis_type_6}</option>

                  <option data-type="analysis">${lng.analysis_type_7}</option>
                  <option value="1" data-type="analysis">${lng.other}</option>
                </select>
              </div>
            </div>
          </li>

          ${(hesitate.type === 'vacc') && $h`
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.type} *</div>
              <div class="item-input-wrap">
                <input type="text" name="vacctype" class="field" value="${hesitate.vacctype||''}" 
                       @change=${save} required placeholder="${lng.insert} tipo" />

              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.date} *</div>
              <div class="item-input-wrap">
                <input type="date" name="date" class="field" value="${hesitate.date||''}" 
                       @change=${save} required placeholder="${lng.insert} ${lng.date}" />

              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.lot} *</div>
              <div class="item-input-wrap">
                <input type="text" name="lotto" class="field" value="${hesitate.lotto||''}" 
                       @change=${save}
                       required placeholder="${lng.insert} ${lng.lot}" />

              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.recall}</div>
              <div class="item-input-wrap">
                <input type="date" name="richiamo" class="field" value="${hesitate.richiamo||''}" 
                       @change=${save} placeholder="${lng.insert} ${lng.recall}" />

              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.notes}</div>
              <div class="item-input-wrap">
                <textarea type="date" name="notes" class="field" value="${hesitate.notes||''}" 
                          @change=${save} placeholder="${lng.insert} ${lng.notes}"></textarea>
              </div>
            </div>
          </li>
          `}
          ${(hesitate.type === 'tratment') && $h`
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.type} *</div>
              <div class="item-input-wrap">
                <input type="text" name="trattype" class="field" value="${hesitate.trattype||''}" @change=${save} 
                       required placeholder="${lng.insert} ${lng.type}" />

              </div>
            </div>
          </li>
          `}
          ${(hesitate.type === 'analysis') && $h`
          <li class="item-content item-input ${
                analysistype_visibility
              }">
            <div class="item-inner">
              <div class="item-input-wrap">
                <input type="text" name="analysistype" class="field" value="${hesitate.analysistype||''}" 
                       @change=${save} required placeholder="${lng.insert} ${lng.analysis_type} *" />
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.values} *</div>
              <div class="item-input-wrap">
                <input type="text" name="analysisvalue" class="field" value="${hesitate.analysisvalue||''}" 
                       @change=${save}
                       required placeholder="${lng.insert} ${lng.analysis_value}" />

              </div>
            </div>
          </li>
          `}

          ${hesitate.type === 'pressure' && $h`
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">PAD (Min) mmHg *</div>
              <div class="item-input-wrap">
                <input type="number" min="60" max="100" required step="any" value="${hesitate['press-min']}" @change=${save} class="field" name="press-min" id="press-min"/>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">PAS (Max) mmHg *</div>
              <div class="item-input-wrap">
                <input type="number"  min="80" max="180" required step="any" value="${hesitate['press-max']}" @change=${save} class="field" name="press-max" id="press-max"/>
              </div>
            </div>
          </li>
          `}

          ${hesitate.type && hesitate.type != 'vacc' && $h`

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.spot} *</div>
              <div class="item-input-wrap">
                <input type="text" name="structure" class="field" value="${hesitate.structure||''}" 
                       @change=${save} required placeholder="${lng.insert} ${lng.spot}" />

              </div>
            </div>
          </li> 
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.date} *</div>
              <div class="item-input-wrap">
                <input type="date" name="date" class="field" value="${hesitate.date||''}" 
                       @change=${save} required placeholder="${lng.insert} ${lng.date}" />

              </div>
            </div>
          </li>

          ${(hesitate.type === 'tratment') ? $h`
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.expiry_date} *</div>
              <div class="item-input-wrap">
                <input type="date" name="scadenza" class="field" value="${hesitate.scadenza||''}" 
                       @change=${save} required placeholder="${lng.insert} ${lng.expiry_date}" />

              </div>
            </div>
          </li>
          `: ''}

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title">${lng.notes}</div>
              <div class="item-input-wrap">
                <textarea type="date" name="notes" class="field" value="${hesitate.notes||''}" 
                          @change=${save} placeholder="${lng.insert} ${lng.notes}"></textarea>
              </div>
            </div>
          </li>
          `}
        </ul>
      </div>

      ${(hesitate.qrcode ||'') && $h`
      <div data-type="qrcode" class="hesitate-image" style="background-image: url(${hesitate.qrcode})" 
           @click=${clickOnImage}></div>
      `}
      ${(hesitate.image || '') && $h`
      <!-- <div data-type="image" class="hesitate-image" style="background-image: url(${hesitate.image})" @click=${clickOnImage}> -->
      <div style="position: relative; width: 250px; margin: 0 auto;">
        <div data-type="image" class="hesitate-image" style="background-image: url(${hesitate.image})" 
             @click=${clickOnImage}></div>
        <i class="f7-icons text-color-white" 
           style="border-radius: 50%; background-color: rgba(255,0,0,.7); padding: 3px; position: absolute; top:3px; right:3px;" 
           @click="${rotateImage}">crop_rotate</i>
      </div>
      `}
      ${(hesitate.document || '') && $h`
      <div class="block text-align-center">
        <div class="document" style="margin: auto" @click=${clickOnDocument}>
          <img src="static/pdf-icon.png"/>
          <div class="document-caption">${hesitate.document.name}</div>
        </div>
      </div>
      `}

      <div class="block">
        ${(hesitate.saved || '') && $h`
        <button class="button button-large button-outline button-round" @click=${saveImage}>
          <i class="f7-icons left">camera</i>
          ${lng.import_certificate}
        </button>
        `}
      </div>

      <div class="block">
        <button class="button button-large button-fill button-round color-secondary" @click=${save} data-show-toast="true">
          <i class="f7-icons left">square_arrow_down</i>
          ${lng.save}
        </button>
      </div>
      `}

      <div style="height: 15vh"></div>
    </div>

    <div class="popup popup-tablet-fullscreen popup-camera1 bg-color-black" @popup:opened=${showCamera} @popup:close=${stopCamera}>
      <video id="video" width="${vw}" height="${vh}" style="position: fixed; left:0; top:0; right: 0; bottom: 0" autoplay playsinline></video>
      <canvas id="canvas" width="${vw}" height="${vh}"></canvas>
      <div style="position:fixed; bottom:0; left:0; right: 0" class="text-align-center">
        <div class="row">
          <div class="col">
            <a href="#" class="button button-large button-fill color-black popup-close">Annulla</a>
          </div>
          <div class="col">
            <a href="#" class="button button-large button-fill color-secondary" @click=${saveCamera}>OK</a>
          </div>
        </div>
      </div>
    </div>

    <form style="display:none">
      <input type="file" accept="image/*" id="fileDialogId1" />
      <input type="file" accept="application/pdf" id="filePDF1" />
    </form>

  </div>
`
    }
    );

          case 53:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();